/**
 * @author Vivek Kumar<vivek.kumar@314ecorp.com>
 * @description React Hook useUpdateClaimRequestById
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for update manual worklist entity
 *
 */

type IUpdateClaimById = {
	claimResource?: Fhir.Claim;
	workState?: ClaimRequest.IClaimWorkState;
	activityLogDescription?: string;
};

const useUpdateClaimById = (id: string): UseMutationResult<unknown, IAxiosError, IUpdateClaimById, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ claimResource, workState, activityLogDescription }) => {
			await api.FHIRClaimApi.patchClaim({
				claimId: id,
				claimPatch: {
					fhirResource: claimResource,
					workState,
					activityLogDescription,
				},
			});
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimRequestById, { id }] });
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimStatusRequests] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateClaimById;
